import { useState } from 'react';
import Button from '@/components/elements/Button';

type InvitationFormProps = {
  allowedRoles: string[];
  safelistedDomains: string[];
  isEntityInvite: boolean;
  inviteUser: (email: string, firstName: string, lastName: string, roles?: string[]) => void;
};
function InvitationForm({ allowedRoles, isEntityInvite = false, inviteUser }: InvitationFormProps) {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [roles, setRoles] = useState<string[]>([]);

  return (
    <div data-cy='invitation-form' className='flex flex-col px-8 pb-4 border-2 rounded-md'>
      <h4>{isEntityInvite ? 'Invite To Company' : 'Invite To Eklipx'}</h4>
      <div className='grid grid-cols-3 gap-2 '>
        <div className='content-center'>
          <label
            htmlFor='base-input'
            className='items-center  inline-block align-middle text-sm font-medium text-gray-900 '
          >
            Email
          </label>
        </div>
        <div className='col-span-2'>
          <input
            type='text'
            name='email'
            className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5'
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
        </div>
        <div className='content-center'>
          <label
            htmlFor='base-input'
            className='items-center  inline-block align-middle text-sm font-medium text-gray-900 '
          >
            First Name
          </label>
        </div>
        <div className='col-span-2'>
          <input
            type='text'
            name='firstName'
            className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5'
            onChange={(e) => {
              setFirstName(e.target.value);
            }}
          />
        </div>
        <div className='content-center'>
          <label
            htmlFor='base-input'
            className='items-center  inline-block align-middle text-sm font-medium text-gray-900 '
          >
            Last Name
          </label>
        </div>
        <div className='col-span-2'>
          <input
            type='text'
            name='lastName'
            className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5'
            onChange={(e) => {
              setLastName(e.target.value);
            }}
          />
        </div>
        {isEntityInvite ? (
          <div className='content-center'>
            <label
              htmlFor='base-input'
              className='items-center  inline-block align-middle text-sm font-medium text-gray-900 '
            >
              Roles
            </label>
          </div>
        ) : null}
        {isEntityInvite ? (
          <div className='col-span-2'>
            {allowedRoles.map((role) => (
              <div key={role} className='flex items-center mb-4'>
                <input
                  id={role}
                  type='checkbox'
                  value=''
                  onChange={(e) => {
                    if (e.target.checked) {
                      setRoles((prevRoles) => [...prevRoles, role]);
                    } else {
                      setRoles((prevRoles) => prevRoles.filter((prevRole) => prevRole !== role));
                    }
                  }}
                  className='w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded '
                />
                <label htmlFor='default-checkbox' className='ms-2 text-sm font-medium text-gray-900 '>
                  {role}
                </label>
              </div>
            ))}
          </div>
        ) : null}
      </div>
      <Button
        buttonText='Invite'
        variant='gradient'
        disabled={!(email.length > 0 && firstName.length > 0 && lastName.length > 0)}
        onClick={() => inviteUser(email, firstName, lastName, roles.length === 0 ? undefined : roles)}
      />
    </div>
  );
}

export default InvitationForm;
